import { BROADCAST_UPLOAD_BACKGROUND } from 'actions/Types';
import { FILL_FRAME, BackgroundStyles } from 'constants/LayerPositions';
import { withCurrentParams, handleDocumentUpload } from 'actions/utils';

/**
 * Upload background is used to upload background files, using s3 proxy apis, to Studio S3 bucket
 */
export default source => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_UPLOAD_BACKGROUND,
      request: async apiClient => {
        const { type, title, file } = source;

        let payload = {
          name: title,
          description: 'Background',
          isStudioMedia: true
        };

        const eventDocId = await handleDocumentUpload(
          apiClient,
          teamId,
          eventId,
          payload,
          file
        );
        payload = {
          source: {
            type,
            title,
            value: eventDocId
          },
          layer: {
            title: FILL_FRAME,
            style: BackgroundStyles[FILL_FRAME]
          }
        };

        const broadcast = await apiClient.broadcast.createBackground(
          teamId,
          eventId,
          broadcastId,
          payload
        );

        const { backgrounds } = broadcast;

        const createdBackground = backgrounds.find(
          background => background.source.value === eventDocId
        );
        return [createdBackground];
      }
    };
    dispatch(action);
  });
};
